import React from 'react';
import { Label, Icon } from '@nooz-optics/nooz-components-lib';
import { ILabel } from '../../../utils/types/contentful';

export interface QuoteProps {
  label: ILabel;
}

export const Quote = ({ label }: QuoteProps) => (
  <div
    className={` ${
      label.color?.classname ? `border-${label.color.classname}` : 'borde-black'
    } flex border-l justify-center items-center w-full my-8`}>
    <div className='p-4 lg:p-8'>
      <Icon
        iconKey='Citation'
        size='5xl'
      />
    </div>
    <div className='w-full'>
      <Label
        italic
        weight='bold'
        size='2xl'
        text={label?.text}
        color={{ classname: label.color.classname }}
      />
    </div>
  </div>
);
